import * as React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default function DsIcon(props) {
   return (
      <SvgIcon
         {...props}
         width="30px"
         height="30px"
         viewBox="0 0 64.000000 64.000000"
      >
         <g
            transform="translate(0.000000,64.000000) scale(0.100000,-0.100000)"
            fill="#000000"
            stroke="none"
         >
            <path
               d="M0 329 c0 -254 1 -271 18 -266 33 10 447 189 460 199 19 16 14 55 -9
72 -24 16 -35 14 -177 -48 -46 -20 -95 -36 -108 -36 -62 0 -114 56 -114 121 0
51 49 86 214 154 80 33 146 63 146 68 0 4 -97 7 -215 7 l-215 0 0 -271z"
            />
         </g>
         <g
            transform="translate(0.000000,64.000000) scale(0.100000,-0.100000)"
            fill="#db441d"
            stroke="none"
         >
            <path
               d="M341 472 c-96 -43 -179 -85 -185 -95 -14 -22 3 -51 33 -55 12 -2 71
17 130 42 125 53 157 56 199 21 60 -51 67 -132 14 -177 -15 -13 -101 -54 -190
-93 l-163 -70 87 -3 c109 -4 178 11 238 48 142 90 169 308 53 428 -17 17 -33
32 -36 32 -4 -1 -84 -36 -180 -78z"
            />
         </g>
      </SvgIcon>
   );
}
